import type { CoinHistoryAggregatedResponse, CalculateRequest } from '@/lib/interfaces/calculator'

export default async function calculate(props: CalculateRequest): Promise<CoinHistoryAggregatedResponse> {
  const body = {
    ...props
  }

  const options = {
    method: 'POST',
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body)
  }
 
  const res = await fetch(`https://user.dipsway.cloud/performances/quote`, options)
    .then(res => res.json())

  return res
}